import { BackButton } from "@src/components/atoms";
import { useDCContext } from "@src/context/dcContext";
import { useOperatorContext } from "@src/context/operatorContext";
import { useAuthContext } from "@src/context/authContext";
import { ONBOARDING_COMMITMENT_OPTIONS } from "@src/constants/constants";

/** Onboarding: Commitment selection — clicking an option submits and advances */
export const OnboardingStep4 = ({
  onNext,
  onBack,
  step,
  previous,
  submitAction,
}) => {
  const { getDynamicReplacement } = useDCContext();
  const { profile, getFirstName, getLastName, roleAlias } =
    useOperatorContext();
  const { operatorMetadata } = profile;
  const auth = useAuthContext();
  const { user } = auth;

  const operatorCommitment =
    operatorMetadata?.find((c) => c.key === "onboarding_commitment")?.value ||
    null;

  const commitmentOptions = ONBOARDING_COMMITMENT_OPTIONS;

  const handleSelect = (optionKey) => {
    const request = {
      firstname: getFirstName(),
      lastname: getLastName(),
      metadata: [
        {
          key: "onboarding_commitment",
          type: "STRING",
          value: optionKey,
        },
      ],
    };
    submitAction && submitAction(request);
    onNext({ commitment: optionKey });
  };

  return (
    <div
      className={`h-full flex flex-col sm:px-2 animate-animated animate-fast ${
        previous < step ? "animate-fadeInRight" : "animate-fadeInLeft"
      }`}
    >
      <div className="grow">
        <div className="flex justify-center py-2">
          <h3 className="leading-none font-extrabold text-center">
            {getDynamicReplacement("onboarding__step5__title")}
          </h3>
        </div>
        <div className="flex justify-center py-4 md:py-6">
          <p className="text-base text-center font-medium">
            {getDynamicReplacement("onboarding__step5__content", {
              ROLE_ALIAS: roleAlias,
              LASTNAME: user.lastname,
            })}
          </p>
        </div>
        <div className="py-1 md:p-2 min-h-24 flex flex-col items-center">
          {Object.keys(commitmentOptions).map((optionKey, idx) => (
            <div key={idx} className="w-full">
              <button
                onClick={() => handleSelect(optionKey)}
                id={optionKey}
                className={`${
                  operatorCommitment === optionKey
                    ? "bg-primary-700"
                    : "bg-primary-500"
                } my-2 w-full rounded-lg shadow text-base border border-transparent px-6 py-2 font-bold text-white hover:bg-primary-600 focus:bg-primary-600 active:bg-primary-600 transition ease-in-out duration-100`}
              >
                {getDynamicReplacement(commitmentOptions[optionKey].label)}
              </button>
            </div>
          ))}
        </div>
      </div>
      <div className="flex justify-center items-center py-6 md:py-8 relative">
        <div className="absolute left-0 p-1">
          <BackButton onCustomBack={onBack} noContainer />
        </div>
      </div>
    </div>
  );
};
